import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { uploadProviderAvatar } from 'actions/provider';
import Button from 'atoms/button';
import ImageUploader from 'atoms/image-uploader';

export default function AvatarUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [image, saveImage] = useState();

  const onNext = async (e) => {
    e.preventDefault();

    if (image) {
      const res = await dispatch(uploadProviderAvatar(image));
      if (res.success) completeSignup();
    } else {
      completeSignup();
    }
  };

  const completeSignup = () => {
    navigate('/services');
  };

  return (
    <div className="flex-column align-center text-center">
      <h1>Upload business logo</h1>
      <form onSubmit={onNext}>
        <ImageUploader
          saveImage={saveImage}
          showEditIcon={false}
          size="big"
          fileName="upload_file"
        />
        <Button
          className="mt-15 mb-20 margin-center"
          type="submit"
          text="Done"
          variant="default"
        />
        <Link className="c-primary-purple pointer" to="/services">
          Skip this step
        </Link>
      </form>
    </div>
  );
}
